import { TokensExtended } from '@unitedtraders/keycloak';
import { AppConfig } from './common';

export type GetTokens = () => Promise<TokensExtended>;

export interface RootProps {
  baseUrl: string;
  locale: string;
  appConfig: AppConfig;
  getTokens: GetTokens;
  closeModal: () => void;
  onSuccessButtonClick?: () => void;
}

export interface RootUpdatable {
  update(attrs: RootProps): void;
}
